// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Layout (top global header).
 */

.gh-header {
  background-color: var(--gh-header-bg);
  color: #ffffff;
  padding: 12px 16px;
}

.gh-header .gh-header-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.gh-header .gh-header-title:hover {
  text-decoration: none;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,qCAAqC;EACrC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB","sourcesContent":["/*\n * Layout (top global header).\n */\n\n.gh-header {\n  background-color: var(--gh-header-bg);\n  color: #ffffff;\n  padding: 12px 16px;\n}\n\n.gh-header .gh-header-title {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.gh-header .gh-header-title:hover {\n  text-decoration: none;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
